import PropTypes from "prop-types";
import React from "react";

import PageBody from "@components/PageBody";
import Report from "@components/Report";
import settings from "@settings/index";
import AdminPageTemplate from "@templates/AdminPage";

function Outbox(props) {
  return (
    <AdminPageTemplate breadcrumbs={props.breadcrumbs}>
      <PageBody title="Caixa de Saída">
        <Report quickSightID={settings.reports.OUTBOX} />
      </PageBody>
    </AdminPageTemplate>
  );
}

Outbox.propTypes = {
  breadcrumbs: PropTypes.array,
};

Outbox.defaultProps = {
  breadcrumbs: [],
};

export default Outbox;
